export const ACHIEVEMENT_VISIBILITIES = {
  PUBLIC: 'PUBLIC',
  PRIVATE: 'PRIVATE'
};
export const URL_PATTERN = /academy\/achievements\/([a-z0-9]{8})\/([a-z]{2})\/(1)\/(.*)/;
export const BROCHURE_URL_BY_LANGUAGE = {
  en: 'https://academy.hubspot.com',
  es: 'https://academy.hubspot.com/es',
  de: 'https://academy.hubspot.de',
  ja: 'https://academy.hubspot.jp',
  pt: 'https://academy.hubspot.com/pt',
  fr: 'https://academy.hubspot.fr'
};